<template>
  <b-modal
    id="admin-create-client-invoice-linked-to-booking-modal"
    :title="trans('new_invoice')"
    size="lg"
    :ok-title="trans('create')"
    :ok-disabled="busy || !canCreate"
    :cancel-title="trans('cancel')"
    @hidden="onHidden"
    @ok="onCreate"
  >
    <p>
      {{ trans('admin_create_client_invoice_linked_to_booking_about') }}
    </p>

    <build-invoice-info-for-booking
      :organization="organization"
      :booking="booking"
      v-model="invoice_info"
      :all-taxes="allTaxes"
      @all-taxes="$emit('all-taxes', $event)"
      :all-gls="allGls"
      @all-gls="$emit('all-gls', $event)"
    ></build-invoice-info-for-booking>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import BuildInvoiceInfoForBooking from './BuildInvoiceInfoForBooking'

  export default {
    props: {
      organization: Object,
      booking: Object,
      allTaxes: Array,
      allGls: Array,
    },
    components: {
      BuildInvoiceInfoForBooking,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        invoice_info: null,
      }
    },
    computed: {
      canCreate() {
        return !!this.invoice_info
      },
    },
    methods: {
      onHidden() {
        this.busy = false
        this.error = null
        this.invoice_info = null
      },
      onCreate(e) {
        e.preventDefault()
        let url = `/organization/${this.organization.id}/invoice/create_linked_to_booking/${this.booking.id}`
        this.busy = true
        this.error = null
        axios.post(url, this.invoice_info)
        .then(response => {
          this.busy = false
          this.$bvModal.hide('admin-create-client-invoice-linked-to-booking-modal')
          this.$emit('added', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.adminCreateClientInvoiceLikedToBookingModal = this
    },
  }
</script>